import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { PropTypes } from 'prop-types';
import { numericality } from 'redux-form-validators';
import format from 'string-template';

class NumberInputFieldComponent extends Component {
    validateDefault = () => {
        let validateDefault = [];
        const { isInteger, min, max, i18nFeatureForm, isRequired } = this.props;
        if (isInteger) {
            validateDefault.push(
                numericality({
                    int: isInteger,
                    msg: i18nFeatureForm.NUMBER_MUSTBEINTEGER,
                    allowBlank: !isRequired
                })
            );
        }
        if (min) {
            validateDefault.push(
                numericality({
                    '>=': min,
                    msg: format(i18nFeatureForm.NUMBER_MIN, min),
                    allowBlank: !isRequired
                })
            );
        }
        if (max) {
            validateDefault.push(
                numericality({
                    '<=': max,
                    msg: format(i18nFeatureForm.NUMBER_MAX, max),
                    allowBlank: !isRequired
                })
            );
        }
        return validateDefault;
    };

    validateMandatory = () => [
        numericality({
            msg: this.props.i18nFeatureForm.NUMBER_INVALID,
            allowBlank: !this.props.isRequired
        })
    ];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                {...this.props}
                type="text"
                normalize={(val, prevVal) => {
                    if (val) {
                        return /^\d+([.,]\d{0,2})?$/.test(val) ? val.replace(',', '.') : prevVal;
                    }
                    return val;
                }}
                validate={[...this.validateDefault(), ...this.validateMandatory(), ...validate]}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js
NumberInputFieldComponent.propTypes = {
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isInteger: PropTypes.bool
};

export default NumberInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/NumberInputFieldComponent.js